import axios from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';

const useUnarchiveStandardizationProject = () => {
  const queryClient = useQueryClient();
  const { mutate, isLoading } = useMutation(async (id) => {
    return await axios.post(`/standardization/${id}/unarchive`);
  });

  const unarchiveProject = (projectId, { onSuccess, onSettled }) => {
    mutate(projectId, {
      onSuccess: (res) => {
        if (!res.data) {
          toast.error(`The project can not be restored!`);
          return;
        }

        queryClient.invalidateQueries('standardizationProjects', { exact: true });
        queryClient.invalidateQueries('archivedStandardizationProjects', { exact: true });

        toast.success(`Successfully restored! `);

        onSuccess && onSuccess(projectId);
      },
      onError: (err) => {
        toast.error(err.message || 'Error! Try again later.');
      },
      onSettled: () => onSettled && onSettled(),
    });
  };

  return {
    unarchiveProject,
    isLoading,
  };
};

export default useUnarchiveStandardizationProject;
